module.exports = __webpack_public_path__ + "img/Picture8.5cb4b29c.jpg";